const form = document.querySelector( '.wp-block-gnist-filter' );

// After a change has been made in the from, submit the form.
form.addEventListener( 'change', function( event ) {
  // submit form. I don't want to prevent default, I want the defualt behaviour to happen.
  setTimeout( function() {
    form.submit();
  }, 200 );
} );